import React from 'react'
import { Route, Redirect } from 'react-router'
import Loadable from 'react-loadable'
import loading from 'components/ui/Loader/Loader'

const AccessContainer = Loadable({ loader: () => import('layers/cityEconomy/containers/AccessContainer/AccessContainer'), loading })
const LoadContainer = Loadable({ loader: () => import('layers/cityEconomy/containers/LoadContainer/LoadContainer'), loading })
const DashboardPage = Loadable({ loader: () => import('layers/cityEconomy/pages/DashboardPage/DashboardPage'), loading })
const ReportPage = Loadable({ loader: () => import('layers/cityEconomy/pages/ReportPage/ReportPage'), loading })
const OperationsPage = Loadable({ loader: () => import('layers/cityEconomy/pages/OperationsPage/OperationsPage'), loading })


export default (links) => (
  <Route component={LoadContainer}>
    <Route component={AccessContainer}>
      <Route path={links.root} component={DashboardPage} />
      <Route path={links.reportEconomy} component={ReportPage} />
      <Route path={links.reportOperations} component={OperationsPage} />

      <Redirect path={`${links.root}/*`} to={links.root} />
    </Route>
  </Route>
)
